module.exports = __webpack_public_path__ + "img/genai1.61744f71.png";